import { render, staticRenderFns } from "./ApprovalsTimePairTable.vue?vue&type=template&id=08fbad6e&scoped=true&"
import script from "./ApprovalsTimePairTable.vue?vue&type=script&lang=js&"
export * from "./ApprovalsTimePairTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalsTimePairTable.vue?vue&type=style&index=0&id=08fbad6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbad6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VCard,VCheckbox,VDataTable,VIcon,VTooltip})
